function init(textureChangedHandler: (texture: string) => void) {
  const container = document.getElementById('ui-container');
  if (!container) {
    console.error(`Container with id ui-container not found.`);
    return;
  }
  const textureSelector = document.createElement('div');
  textureSelector.id = 'textureSelector';
  const textures = ['T90A', 'T90B', 'T90C', 'T90D', 'T90E', 'T90F', 'T90G'];
  textures.forEach((texture) => {
    const textureButton = document.createElement('button');
    textureButton.classList.add('texture-button');
    const img = document.createElement('img');
    img.src = `../assets/models/T90/${texture}.png`;
    img.alt = `Texture ${texture}`;
    textureButton.appendChild(img);
    textureButton.addEventListener('click', () => changeTexture(texture));
    textureSelector.appendChild(textureButton);
  });
  container.appendChild(textureSelector);

  const infoBox = document.createElement('div');
  infoBox.id = 'infoBox';
  const offlineBlock = document.createElement('div');
  offlineBlock.classList.add('infoBlock');
  offlineBlock.innerHTML = `
        <h2>OFFLINE</h2>
        <input type="text" id="usernameInput" placeholder="Jméno" oninput="updateUsername()">
        <p>Server Name: MyGameServer</p>
        <p>Connection Status: Waiting...</p>
        <p>Players Connected: 0/20</p>
    `;
  const activeServersBlock = document.createElement('div');
  activeServersBlock.classList.add('infoBlock');
  activeServersBlock.innerHTML = `
        <h2>Active Servers</h2>
        <p>Připraven</p>
        <p>Připojeno k: MyGameServer</p>
    `;
  infoBox.appendChild(offlineBlock);
  infoBox.appendChild(activeServersBlock);
  container.appendChild(infoBox);

  function changeTexture(texture: string) {
    textureChangedHandler(texture);
  }
}

function dispose() {
  const container = document.getElementById('ui-container');
  if (!container) {
    console.error(`Container with id ui-container not found.`);
    return;
  }
  const textureSelector = document.getElementById('textureSelector');
  if (textureSelector) {
    const textureButtons = textureSelector.querySelectorAll('.texture-button');
    textureButtons.forEach((textureButton) => {
      textureButton.replaceWith(textureButton.cloneNode(true));
    });
    container.removeChild(textureSelector);
  }
  const infoBox = document.getElementById('infoBox');
  if (infoBox) {
    container.removeChild(infoBox);
  }
}

export const GarageUI = {
  init,
  dispose,
};

